import { useApi } from '../services';

export const useGetTeams = (idPerson) => useApi(
  `/v2/team/${idPerson}`,
  'GET',
  {},
  {}
);

export const useUpdateTeamsAsync = (idPerson) => useApi(
  `/v2/team/${idPerson}`,
  'PUT',
  {},
  {},
  true
);